import { render, staticRenderFns } from "./BudgetListItem.vue?vue&type=template&id=a5d813aa&scoped=true&"
import script from "./BudgetListItem.vue?vue&type=script&lang=js&"
export * from "./BudgetListItem.vue?vue&type=script&lang=js&"
import style0 from "./BudgetListItem.vue?vue&type=style&index=0&id=a5d813aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d813aa",
  null
  
)

export default component.exports